import React from "react";
import Breadcrumb from "../../Components/Breadcrumb/Breadcrumb";
import AllAcountsSection from "../../Components/AllAccountsSection/AllAcountsSection";
import { Link } from "react-router-dom";

import MobileStoreButton from "react-mobile-store-button";
import ContainsArea from "../../Components/ContainsArea/ContainsArea";

import bgimg from "../../assets/images/IZB/IZB Website Skin/IZB Save Plus Account/image_6.png";
import { AiFillCaretRight, AiOutlineRight } from "react-icons/ai";
import { useEffect } from "react";
import VideoSlider from "../../Components/VideoSlider/VideoSlider";


const MobileBanking = () => {
  const bannerPhones = "https://izbassetsmain.blob.core.windows.net/izbwebassets/Group 1000003036.png";
  const bannerPhones1 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/Indo-Banking-New.png";

  // New benefit icons
  const remittancesIcon = "https://izbassetsmain.blob.core.windows.net/izbwebassets/exchange_4738556%201%20(Colorized).png";
  const qrPaymentsIcon = "https://izbassetsmain.blob.core.windows.net/izbwebassets/qr-code-scan_4750308%201%20(Colorized).png";
  const termDepositsIcon = "https://izbassetsmain.blob.core.windows.net/izbwebassets/save-money_11062853%201%20(Colorized).png";
  const walletTransfersIcon = "https://izbassetsmain.blob.core.windows.net/izbwebassets/wire-transfer_18987599%201%20(Colorized).png";
  const cardlessWithdrawalsIcon = "https://izbassetsmain.blob.core.windows.net/izbwebassets/withdraw-money_18583760%201%20(Colorized).png";
  const biometricIcon = "https://izbassetsmain.blob.core.windows.net/izbwebassets/biometric_17782810%201%20(Colorized).png";
  const cardManagementIcon = "https://izbassetsmain.blob.core.windows.net/izbwebassets/credit-card_10687526%201%20(Colorized).png";
  const billPaymentsIcon = "https://izbassetsmain.blob.core.windows.net/izbwebassets/invoice_9256718%201%20(Colorized).png";
  const schoolPaymentsIcon = "https://izbassetsmain.blob.core.windows.net/izbwebassets/scholarship_5741562%201%20(Colorized).png";

  const BackgroundBrundcrumb = "https://izbassetsmain.blob.core.windows.net/izbwebassets/indo-mobile-banking-banner.png";

  const img = "https://izbassetsmain.blob.core.windows.net/izbwebassets/mobile-banking-single-page.png";

  const Logo = "https://izbassetsmain.blob.core.windows.net/izbwebassets/Group 402.png";
  const Logo1 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/Group 403.png";
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])
  const textColor = {
    color: "#9E1B1E",
  };
  const iosUrl =
    "https://apps.apple.com/in/app/izb-mobile-banking/id6754076496";
  const androidUrl =
    "https://play.google.com/store/apps/details?id=com.izb.mobile";
  const content =
    "Indo NXT Mobile Banking  gives you access to your account on your mobile/tab device. Perform your banking tasks from the palm of your hand, from anywhere and at anytime!";
  return (
    <>
      <Breadcrumb Heading="Indo NXT Mobile Banking" img={BackgroundBrundcrumb} />
      <section className="overview-area">
        <div className="container">
          <div className="row">
            <div className="col-md-5 col-xl-5">
              <div className="overview-content-box-one">
                <img src={img} width="100%" alt="" />
              </div>
            </div>
            <div className="col-xl-6 col-md-6 ">
              <div className="overview-content-box-two h-100 d-flex flex-column justify-content-center">
                <div className="inner-title">
                  <h5>Know About</h5>
                  <h2>Indo NXT Mobile Banking </h2>
                </div>
                <div className="text">
                  <p>{content}</p>
                </div>
                <div className=" align-items-center">
                  <Link to={androidUrl} target="_blank" >
                    <img src={Logo} width={150} style={{ textDecoration: "none", border: "none" }} />
                  </Link>
                  <Link to={iosUrl} target="_blank">
                    <img src={Logo1} width={150} />
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <ContainsArea />

      <section
        id="benefits"
        class="benefits-style2-area"
        className="choose-style1-area"
      >
        <div className="container pt-4">
          <div className="text-center my-5">
            <h1 style={{ color: "#484848" }}>Indo NXT Mobile Banking Benefits</h1>
            <p style={{ color: "#484848" }}>
              We help Businesses and customers achieve more.
            </p>
          </div>
          <div className="d-flex justify-content-center">
            <ul className="row choose-style1__content">
              <li className="col-xl-3 col-lg-3 single-choose-style1-colum text-center">
                <div className="single-choose-style1">
                  <div className="icon">
                    <img src={remittancesIcon} alt="" />
                  </div>
                  <div className="text">
                    <h5>Domestic and international remittances</h5>
                  </div>
                </div>
              </li>
              <li className="col-xl-3 col-lg-3 single-choose-style1-colum text-center">
                <div className="single-choose-style1">
                  <div className="icon">
                    <img src={walletTransfersIcon} alt="" />
                  </div>
                  <div className="text">
                    <h5>Bank to Wallet transfers</h5>
                  </div>
                </div>
              </li>
              <li className="col-xl-3 col-lg-3 single-choose-style1-colum text-center">
                <div className="single-choose-style1">
                  <div className="icon">
                    <img src={qrPaymentsIcon} alt="" />
                  </div>
                  <div className="text">
                    <h5>QR Payments</h5>
                  </div>
                </div>
              </li>
              <li className="col-xl-3 col-lg-3 single-choose-style1-colum text-center">
                <div className="single-choose-style1">
                  <div className="icon">
                    <img src={cardlessWithdrawalsIcon} alt="" />
                  </div>
                  <div className="text">
                    <h5>Cardless withdrawals</h5>
                  </div>
                </div>
              </li>
              <li className="col-xl-3 col-lg-3 single-choose-style1-colum text-center">
                <div className="single-choose-style1">
                  <div className="icon">
                    <img src={termDepositsIcon} alt="" />
                  </div>
                  <div className="text">
                    <h5>Open Term Deposits</h5>
                  </div>
                </div>
              </li>
              <li className="col-xl-3 col-lg-3 single-choose-style1-colum text-center">
                <div className="single-choose-style1">
                  <div className="icon">
                    <img src={billPaymentsIcon} alt="" />
                  </div>
                  <div className="text">
                    <h5>Bill payments</h5>
                  </div>
                </div>
              </li>
              <li className="col-xl-3 col-lg-3 single-choose-style1-colum text-center">
                <div className="single-choose-style1">
                  <div className="icon">
                    <img src={schoolPaymentsIcon} alt="" />
                  </div>
                  <div className="text">
                    <h5>School payments</h5>
                  </div>
                </div>
              </li>
              <li className="col-xl-3 col-lg-3 single-choose-style1-colum text-center">
                <div className="single-choose-style1">
                  <div className="icon">
                    <img src={cardManagementIcon} alt="" />
                  </div>
                  <div className="text">
                    <h5>Card management services</h5>
                  </div>
                </div>
              </li>
              <li className="col-xl-12 col-lg-12 single-choose-style1-colum text-center">
                <div className="single-choose-style1">
                  <div className="icon">
                    <img src={biometricIcon} alt="" />
                  </div>
                  <div className="text">
                    <h5>Biometric authentication</h5>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </section>

      <section
        id="eligibility"
        class="eligibility-area how-to-sign-up-for-mobilebanking"
        style={{ backgroundColor: "#FFF5E7" }}
      >
        <div className="container-fluid">
          <div className="sec-title text-center">
            <h2>How to Sign Up for Indo NXT Mobile Banking</h2>
            {/* <div className="sub-title">
              <p>Basic documents required for opening a savings account.</p>
            </div> */}
          </div>
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-xl-12 col-lg-12">
                {/*Start Single Documents Box*/}
                <div
                  className="single-documents-box h-100"
                  style={{ backgroundColor: "#9E1B1E" }}
                >
                  <ul>
                    <li>
                      <div className="inner-title">
                        <p className="text-white">
                          Download the IZB NXT APP for the Google Playstore / App store.
                        </p>
                      </div>
                    </li>
                    <li>
                      <div className="inner-title">
                        <p className="text-white">
                          Open the IZB NXT App and click on register for digital banking
                        </p>
                      </div>
                    </li>
                    <li>
                      <div className="inner-title">
                        <p className="text-white">
                          Enter your account number, mobile number and identity number.
                        </p>
                      </div>
                    </li>
                    <li>
                      <div className="inner-title">
                        <p className="text-white">
                          Enter your Username, passwords and confirm passwords
                        </p>
                      </div>
                    </li>
                    <li>
                      <div className="inner-title">
                        <p className="text-white">
                          Verify your details by entering your debit card details
                        </p>
                      </div>
                    </li>
                    <li>
                      <div className="inner-title">
                        <p className="text-white">
                          Set up three (3) security questions for future passwords resets.
                        </p>
                      </div>
                    </li>
                    <li>
                      <div className="inner-title">
                        <p className="text-white">
                          Proceed to Login and Bank easily.
                        </p>
                      </div>
                    </li>
                  </ul>
                </div>
                {/*End Single Documents Box*/}
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="overview-area">
        <div className="container">
          <div className="row">
            <div
              className=" col-md-6 col-xl-6"
            >
              <div className="overview-content-box-one text-center">
                <img
                  src={bannerPhones1}
                  width="360px"
                  alt=""
                />
              </div>
            </div>
            <div className="col-xl-6 col-md-6 ">
              <div className="overview-content-box-two h-100 d-flex flex-column justify-content-center">
                <div className="inner-title">
                  <h2 style={textColor}>Indo NXT Mobile Banking </h2>
                  <div className="d-flex align-items-center gap-3 my-3">
                    <h5 style={textColor}>Anytime, Anywhere.</h5>
                  </div>
                  <p>
                    Indo NXT Mobile Banking  gives you access to your account on your
                    mobile/tab device. Perform your banking tasks from the palm
                    of your hand, from anywhere and at anytime!
                  </p>
                  <h3 className="py-3" style={textColor}>
                    USSD Dial *232#
                  </h3>
                </div>
                <div className="d-flex align-items-center mb-3">
                  <Link to={androidUrl} target="_blank">
                    <img src={Logo} width={150} style={{ textDecoration: "none", border: "none" }} />
                  </Link>
                  <Link to={iosUrl} target="_blank">
                    <img src={Logo1} width={150} />
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

 <section className="py-5" style={{ backgroundColor: "#f9f9f9" }}>
  <div className="container-fluid px-4">
    <div className="text-center mb-4">
      <h2 style={{ color: "#9E1B1E" }}>
        Explore our IZB NXT Mobile banking tutorial videos
      </h2>
    </div>

    <div
      style={{
        display: "flex",
        justifyContent: "center",
        gap: "20px",
        overflowX: "auto",
        overflowY: "hidden",
        paddingBottom: "10px",
        scrollSnapType: "x mandatory",
        WebkitOverflowScrolling: "touch",
      }}
    >
      {[
        { src: "https://www.youtube.com/embed/DvATVKEuCas", title: "IZB NXT Mobile Banking Tutorial 1" },
        { src: "https://www.youtube.com/embed/fspEuzSE978", title: "IZB NXT Mobile Banking Tutorial 2" },
        { src: "https://www.youtube.com/embed/KxunBsnWMRY", title: "IZB NXT Mobile Banking Tutorial 3" },
        { src: "https://www.youtube.com/embed/90ZJWiz8LJE", title: "IZB NXT Digital Banking Tutorial" },
      ].map((v) => (
        <div
          key={v.src}
          style={{
            flex: "0 0 auto",
            scrollSnapAlign: "center",
          }}
        >
          <iframe
            width="260"
            height="460"
            src={v.src}
            title={v.title}
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            style={{
              borderRadius: "12px",
              display: "block",
            }}
          />
        </div>
      ))}
    </div>
  </div>
</section>
    </>
  );
};

export default MobileBanking;
